import React from 'react';
import { Spinner } from '@economic/taco';

import Error from './steps/error/Error';
import Success from './steps/success/Success';
import Overview from './steps/overview/Overview';
import SelectPlan from './steps/selectPlan/SelectPlan';
import DialogFooter from '../../DialogFooter/DialogFooter';
import SignupDialogTitle from './steps/SignupDialogTitle';
import CompanyInformation from './steps/companyInformation/CompanyInformation';
import { UserInformation } from './steps/userInformation/UserInformation';
import { SmartPayOnboardingSteps } from '../../../../types';
import { useSignupDialogNavigation } from '../hooks/useSignupDialogNavigation';
import { useSignupDialogOnboardingContext } from '../contexts/SignupDialogOnboardingContextProvider';

const SignupDialogContent = ({ closeDialog }) => {
    const { onboardError } = useSignupDialogOnboardingContext();
    const { currentStep, isLoading } = useSignupDialogNavigation();

    return (
        <>
            <SignupDialogTitle />
            {isLoading ? (
                <div className="flex justify-center items-center w-full " style={{ height: '500px' }}>
                    <Spinner delay={0} />
                </div>
            ) : onboardError ? (
                <Error closeDialog={closeDialog} />
            ) : currentStep === SmartPayOnboardingSteps.OVERVIEW ? (
                <Overview closeDialog={closeDialog} />
            ) : currentStep === SmartPayOnboardingSteps.USER_INFORMATION ? (
                <UserInformation />
            ) : currentStep === SmartPayOnboardingSteps.COMPANY_INFORMATION ? (
                <CompanyInformation />
            ) : currentStep === SmartPayOnboardingSteps.PLAN ? (
                <SelectPlan />
            ) : currentStep === SmartPayOnboardingSteps.SUCCESS ? (
                <Success closeDialog={closeDialog} />
            ) : null}
            <DialogFooter />
        </>
    );
};

export default SignupDialogContent;
